import React from 'react';
import {MasterLayout} from 'layout';
import { header } from 'constants/table';
import {ThongKeBaoCao} from 'api';
import DataTable from 'components/data-table';
import {RowItemChiTietDonViBCTH} from './datatable';
import {ContainerFileDinhKem} from 'components/upload';
import {Link, browserHistory} from 'react-router';
import { Button } from '@blueprintjs/core';

class ChiTietDonViBCTH extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: {
        listTaiLieuBaoCao: [],
        baoCaoTongHopInfo: {}
      },
      loaiBaoCao: [],
      tableLoading: false
    }
  }

  componentDidMount() {
    if (this.props.params.id) {
      this.getInfo(this.props.params.id);
      this.getLoaiBaoCaoList(this.props.params.id);
    }
  }

  getInfo(idBC) {
    ThongKeBaoCao.actions.getBaoCaoDinhKyChiTiet.request({id: idBC}).then(res => {
      if (res.data) {
        this.setState({
          data: res.data
        });
      }
    });
  }
  getLoaiBaoCaoList(idBC) {
    this.setState({tableLoading: true});
    ThongKeBaoCao.actions.getBaoCaoDinhKyLoaiDon.request({id: idBC}).then(res => {
      if (res.data && res.data._embedded) {
        this.setState({
          loaiBaoCao: res.data._embedded.baoCaoDonViChiTiets,
          tableLoading: false
        });
      } else {
        this.setState({
          loaiBaoCao: [],
          tableLoading: false
        });
      }
    });
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container wrap-block" ref='thongKeBaoCao'>
          <div className="back-foward mb0">
            <Link onClick={browserHistory.goBack}>Về trang trước</Link>
          </div>
          <div className="top-content">
            <div className="left-content">
                <p className="title-18"><i className="tt tt-thongke"></i>{this.state.data.baoCaoTongHopInfo ? this.state.data.baoCaoTongHopInfo.tenBaoCao : ''} năm {this.state.data.baoCaoTongHopInfo ? this.state.data.baoCaoTongHopInfo.namBaoCao : ''} của {this.state.data.donViInfo ? this.state.data.donViInfo.ten : ''}</p>
            </div>
          </div>
          <div className="bottom-content thongke-content">
            <div className='row pl10 pr10'>
              <h2 className='title-14 col-100 pt20 pl20 pr20'>1. Danh sách biểu mẫu</h2>
            </div>
            <div className="wrap-table clear-left">
              <DataTable
                header={header.chiTietDonViBCTH}
                dataList={this.state.loaiBaoCao}
                hidePagination
                parent={this}
                hideButtonExport
                tableLoading={this.state.tableLoading}
              >
                <RowItemChiTietDonViBCTH/>
              </DataTable>
            </div>
            <div className='row pl15 pr15 pb15'>
              <span className='big-border'></span>
            </div>
            <div className='row pl30 pr30 '>
              <ContainerFileDinhKem label="2. Danh sách văn bản xử lý" labelClass="title-14" disableTopLine={true} disableAttachFile={true} dataShow={this.state.data.listTaiLieuBaoCao}/>
            </div>
          </div>
          <div className="pt30">
            <div className="box-bottom">
              <Button type="button" className="btn-action btn-close" onClick={browserHistory.goBack}><span>Đóng</span></Button>
            </div>
          </div>
        </div>
      </MasterLayout>
    );
  }
}

export default ChiTietDonViBCTH;



// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/ChiTietDonViBCTH.jsx